import { OptionList } from '@/shared/lib/interfaces/option.interface';

export const formatAutocomplete = (options: OptionList, values: string[]) =>
	values.map((v) => options.find(({ value }) => v === value)?.label).join(', ');
